import { render, staticRenderFns } from "./RenameWorkspace.vue?vue&type=template&id=4159b87c&scoped=true"
import script from "./RenameWorkspace.vue?vue&type=script&lang=js"
export * from "./RenameWorkspace.vue?vue&type=script&lang=js"
import style0 from "./RenameWorkspace.vue?vue&type=style&index=0&id=4159b87c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4159b87c",
  null
  
)

export default component.exports